import React from 'react';
import EnumsAdmin from './EnumsAdmin';
import Api from '../../api'; // Adjust the import path and service as necessary

const EstadosAdmin = () => {
  return <EnumsAdmin enumType="Estado" apiService={Api.Enums.Estados} />;
};

export default EstadosAdmin;
